import React from "react";
import { AllMembers } from "./../Home/Member/All_Members";

export const Technical = () => {
  //    TECHNICAL PROGRAM COMMITTEE
  const Name1 = ["Azizuddin Khan ",
  "Dae-Ki Kang",
  "Dhananjay Singh",
  "Gokarna Sharma",
  "Young Jin Jung",
  "Srivathsan Srinivasagopalan ",
  "Yongseok Chi",
  "Rajesh Sankaran",
  "Jungyoon Kim",
  "Younghoon Chae",
  "Ayan Dutta   ",
  "Jangwoon Park ",
  "Slim Rekhis",
  "Boudriga Nourddine",
  "Kambiz Ghaginour",
  "Nagarajan Prabakar",
  "Dang Peng",
  "Jakyung Seo",
  "Elena Novak",
  "Mohd Helmy Abd Wahab",
  "Masoud Mohammadian",
  "Arvind W Kiwelekar ",
  "James Folkestad",
  "Julio Ariel Hurtado Alegria ",
  "NS Rajput ",
  "Ho Jiacang",
  "Ahmed Abdulhakim Al-Absi ",
  "Rodrigo da Rosa Righi",
  "Nagesh Yadav",
  "Jan Willem van’t Klooster",
  "Hasan Tinmaz",
  "Zhong Liang Xiang",
  "Hanumant Singh Shekhawat",
  "Md. Iftekhar Salam",
  "Alvin Poernomo",
  "Surender Reddy Salkuti",
  "Suzana Brown",
  "Dileep Kumar",
  "Prima Sanjaya",
  "Thierry Oscar Edoh",
  "David (Bong Jun) Choi", 
  "Gyanendra Verma",
  "Alex Wong Ming Hui",
  "Bharat Rawal",
  "Wesley De Neve",
  "Satish Kumar L. Varma",
  "Alex Kuhn",
  "Mark Whitaker",
  "Satish Srirama",
  "Nagamani Molakatala",
  "Shyam Perugu",
  "Neeraj Parolia",
  "Stella Tomasi",
  "Marcelo Marciszack",
  "Andres Navarro- Newball ",
  "Marcelo Marciszak",
  "Indranath Chatterjee",
  "Gaurav Tripathi",
  "Bernardo Nugroho Yahya",
  "Carlene Campbell",
  "Anwar Alluwari",
  "Sayed Chhattan Shah",
  "Rajesh Mishra",
  "Mario Divan",
  "Jaehyun Park",
  "Hyun K. Kim"
];

  const Info1 = [" (Indian Institute of Technology Bombay, India)",
  "(Dongseo University, South Korea)",
  " (HUFS, South Korea)",
  "(Kent State University, USA)",
  "(Dongseo University, South Korea)",
  "(AT&T, USA)",
  "(Dongseo University, South Korea)",
  "(Argonne National Laboratory, USA)",
  "(Kent State University, USA)",
  "(Kent State University, USA)",
  "(University of North Florida, USA)",
  "(Texas A&M University, USA)",
  "(University of Carthage, Tunisia)",
  "(University of Carthage, Tunisia)",
  "(SUNY, USA)",
  "(Florida International University, USA)",
  "(Florida International University, USA)",
  "(Kent State University, USA)",
  "(Kent State University, USA)",
  "(Universiti Tun Hussein Onn, Malaysia)",
  "(University of Canberra, Australia)",
  "(Dr Babasaheb Ambedkar Technological University-Lonere, India)",
  "(Colorado State University, USA)",
  "(University of Cauca, Colombia)",
  "(Indian Institute of Technology-BHU, India)",
  "(Dongseo University, Korea)",
  "(Kyungdong University, Korea)",
  "(UNISINOS, Brazil)",
  "(IBM Research, Ireland)",
  "(University of Twente, The Netherlands)",
  "(Woosong University, Korea)",
  "(Shandong Technology & Business University, China)",
  "(Indian Institute of Technology, Guwahati, India)",
  "(Xiamen University, Malaysia)",
  "(University of New Brunswick, Canada)",
  "(Woosong University, Korea)",
  "(State University of New York, Korea)",
  "(MR Research, SIEMENS HealthCare, India)",
  "(University of Helsinki, Finland)",
  "(Bonn University, Germany)",
  "(Soongsil University, Korea)",
  "(NIT Kurukshetra, India)",
  "(Osaka University, Japan)",
  "(Gannon University, USA)",
  "(Ghent University Global Campus,  Korea)",
  "(Pillai College of Engineering, India)",
  "(State University of New York, Korea)",
  "(State University of New York, Korea)",
  "(University of Hyderabad, India)",
  " (University of Hyderabad, India)",
  "(National Institute of Technology, Warangal, India)",
  "(Towson University, Maryland, USA)",
  "(Towson University, Maryland, USA)",
  "(National University of Technology, Argentina)",
  "(Pontificia Universidad Javeriana, Colombia)",
  "(Grupo de Investigación en Tech. Info. Avanzadas)",
  "(Tongmyong University Busan South Korea)",
  "(BEL, India)",
  "(HUFS, Korea)",
  "(University of Wales Trinity Saint David, UK)",
  "(Stevens Institute of Technology, USA)",
  "(Hankuk University of Foreign Studies (HUFS), Korea)",
  "(Gautam Buddha University, India)",
  "(INTEL Cooperation, USA)",
  "(Incheon National University, South Korea)",
  "(Kwangwoon University, South Korea)"
];

  return (
    <section className="container">
      <AllMembers heading="" Name={Name1} Info={Info1} />
      <hr className="hr-style" />
    </section>
  );
};
